import { render, staticRenderFns } from "./SubShelvesManage.vue?vue&type=template&id=976b3eb0&scoped=true"
import script from "./SubShelvesManage.vue?vue&type=script&lang=js"
export * from "./SubShelvesManage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "976b3eb0",
  null
  
)

export default component.exports